import { v4 as uuidv4 } from 'uuid';

export function addInInactiveSubscriptions({ subscription }) {
    subscription.isActive = false;
    subscription.failReasons = [{ reason: 'unsubscribe action requested', time: new Date().toISOString() }];
    this.inactiveSubscriptions.push(subscription);

    delete this.connectedSchedules[subscription.id];
    delete this.availableSchedules[subscription.id];
    delete this.availableSchedulesLoaded[subscription.id];

    this.observed.subscriptions = uuidv4();
    this.observed.availableSchedules = uuidv4();
}
